import request from '@/utils/request'

const activitiesSetURL = {
  List: 'platform-activity/list',
  Created: 'platform-activity/create',
  Update: 'platform-activity/update',
  Delete: 'platform-activity/delete'
}

// 获奖列表 & 详情(参数传id = *)
export function fetchActivitiesSetList (params) {
  return request({
    url: activitiesSetURL.List,
    method: 'get',
    params
  })
}

// 新增
export function createdActivitiesSet (data) {
  return request({
    url: activitiesSetURL.Created,
    method: 'post',
    data
  })
}

// 修改
export function updateActivitiesSet (data) {
  return request({
    url: activitiesSetURL.Update,
    method: 'post',
    data
  })
}

// 删除
export function deleteActivitiesSet (data) {
  return request({
    url: activitiesSetURL.Delete,
    method: 'post',
    data
  })
}

export default {
  fetchActivitiesSetList,
  createdActivitiesSet,
  updateActivitiesSet,
  deleteActivitiesSet
}
